<button
  *ngIf="localeData.supported.length > 1"
  style="margin-left: 10px"
  mat-button
  mat-stroked-button
  [color]="color || 'primary'"
  [matMenuTriggerFor]="localeMenu"
>
  {{ localeData.current }} <mat-icon>arrow_drop_down </mat-icon>
</button>
<mat-menu #localeMenu="matMenu">
  <a
    *ngFor="let lang of localeData.supported"
    mat-menu-item
    [href]="lang.url"
    >{{ lang.label }}</a
  >
</mat-menu>
